enum _3DModelDetailLevel {
    CLOUDPOINTS = "cloudpoints",
    HIGH_POLY = "high poly",
    MEDIUM_POLY = "medium poly",
    LOW_POLY = "low poly",
  }
  
  export default _3DModelDetailLevel;